module.exports = __webpack_public_path__ + "media/Video 45.64c7553c.mp4";